export enum ExportAmountType {
    Day,
    Week,
    Month,
    Year,
}
